<script>
  import HimekuriAnswered from '@/components/atoms/HimekuriAnswered'
  import HimekuriCover from '@/components/atoms/HimekuriCover'
  import HimekuriInput from '@/components/atoms/HimekuriInput'
  import HimekuriOver from '@/components/atoms/HimekuriOver'
  import HimekuriFinish from '@/components/atoms/HimekuriFinish'
  import HimekuriNum from '@/components/atoms/HimekuriNum'
  import { differenceInSeconds } from 'date-fns';
  import pageScroll from '@/mixins/page-scroll';

  export default {
    name: 'HimekuriCalendar',
    components: {
      HimekuriAnswered,
      HimekuriCover,
      HimekuriInput,
      HimekuriOver,
      HimekuriFinish,
      HimekuriNum
    },
    props: [
      'isExpired'
    ],
    data() {
      const lastDate = new Date(2020, 2, 17, 0, 0);
      let state = 0;

      if (differenceInSeconds(new Date(), lastDate) > 0) {
        // 参加期間終了判定
        state = 3;
        this.$store.commit('OpenAnsweredArea');
      } else if (this.$store.state.answeredIds.length >= 24) {
        // 全回答終了判定
        state = 4;
      } else if (this.$store.state.isLimited) {
        if (this.$store.state.todaysAnswerNum >= 5) {
          // 今日の回答終了判定
          state = 2;
        }
      }
      return {
        state
      }
    },
    methods: {
      showQuestion() {
        this.state = 1;
        this.$store.commit('OpenAnsweredArea');
      },
      scroll() {
        const element = document.getElementById("top");
        const y = window.pageYOffset;
        const top = element.getBoundingClientRect().top;
        pageScroll(y, top + y);
      },
    },
    watch: {
      isExpired() {
        const lastDate = new Date(2020, 2, 17, 0, 0);
        if (differenceInSeconds(new Date(2020, 2, 17, 0, 1), lastDate) > 0) {
          // 参加期間終了判定
          this.state = 3;
        }
      }
    }
  }
</script>

<template lang="pug">
  .himekuri-calendar
    img.himekuri-calendar__arrow(
      src = '~@/assets/img/scroll_arrow.svg'
      @click = 'scroll'
      )
    .himekuri-calendar__copy#top
      |今日のクエスチョンに答えよう！
    .himekuri-calendar__header
      .himekuri-calendar__number
        HimekuriNum(
          :num = '$store.state.currentQuestionCount'
          :fill = 'true'
          )
    .himekuri-calendar__content
      transition-group(
        name = 'himekuri'
        )
        HimekuriCover(
          key = 'cover'
          v-if = 'state === 0 && $store.state.answeredIds.length < 24'
          @click = 'showQuestion'
          )
        HimekuriInput(
          key = 'input'
          v-else-if = 'state === 1 && $store.state.answeredIds.length <= 24'
          )
        HimekuriAnswered(
          key = 'answered'
          v-else-if = 'state === 2 && $store.state.answeredIds.length < 24'
          )
        HimekuriOver(
          key = 'over'
          v-else-if = 'state === 3'
          )
        HimekuriFinish(
          key = 'finish'
          v-else-if = 'state === 4'
          )
</template>

<style lang="scss">
  .himekuri-calendar {
    width: 315px;
    margin-right: auto;
    margin-left: auto;
    @include l-mobile {
      padding-top: 9px;
    }
    &__arrow {
      @include l-more-than-mobile {
        display: none;
      }
      @include l-mobile {
        display: block;
        margin-bottom: 15px;
        margin-right: auto;
        margin-left: auto;
      }
    }
    &__copy {
      @include l-more-than-mobile {
        display: none;
      }
      @include l-mobile {
        margin-bottom: 20px;
        color: #fff;
        @include fontSize(18);
        font-weight: 700;
        text-align: center;
      }
    }
    &__header {
      width: 100%;
      position: relative;
      padding-top: 110 / 630 * 100%;
      background-image: url('~@/assets/img/calendar.png');
      background-size: 100% 100%;
    }
    &__number {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      position: absolute;
      top: 25px;
      left: 0;
    }
    &__content {
      height: 378px;
      position: relative;
      background-color: $base-color;
    }

    // interaction
    &__arrow {
      animation: arrow 0.8s $easeOutCubic 0s infinite alternate;
    }
  }

  @keyframes arrow {
    0% {
      transform: translateY(8px);
    }
    100% {
      transform: translateY(0);
    }
  }
</style>
